import { useMutation, useQueryClient } from "@tanstack/react-query"
import { makeCancelAllDocuments } from "../../domain/use-cases/cancel-all-documents"
import { httpDocumentRepository } from "../../data/repositories/document-repository"

const cancelAllDocuments = makeCancelAllDocuments(httpDocumentRepository)

export const useStopAllDocuments = (kbId: string) => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => cancelAllDocuments(kbId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["documents"] }),
  })
}
